export default __webpack_public_path__ + "static/media/sold_out.9b3f0f73.png";